const SundriesIcon = ({ color = '#314158', width = '16px', height = '16px' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#sundriesIconClip)">
				<path d="M7.99967 10.6654C9.47243 10.6654 10.6663 9.47146 10.6663 7.9987C10.6663 6.52594 9.47243 5.33203 7.99967 5.33203C6.52692 5.33203 5.33301 6.52594 5.33301 7.9987C5.33301 9.47146 6.52692 10.6654 7.99967 10.6654Z" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M8 1.33203V2.66536" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M8 13.332V14.6654" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M3.28711 3.28516L4.22711 4.22516" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M11.7734 11.7734L12.7134 12.7134" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M1.33301 8H2.66634" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M13.333 8H14.6663" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M4.22711 11.7734L3.28711 12.7134" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M12.7134 3.28516L11.7734 4.22516" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
			</g>
			<defs>
				<clipPath id="sundriesIconClip">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default SundriesIcon;
